import { Box, Button, IconButton } from "@mui/material";
import { t } from "i18next";
import { ClientPassportButton } from "../../../../components/buttons/ClientPassportButton";
import BaseTable from "../../../../components/table/BaseTable";
import DeleteIcon from "@mui/icons-material/Delete";
import { useRemovePersonComapnyMutation } from "../../../../services/customersService";
import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../../../components/base/SnackbarAlert/SnackbarSuccess";
import { useToasts } from "../../../../hooks/useToasts";


export function ConectedPersonsTable(props) {
    // Define headers as strings.
    const headers = [
        t("clients.passportDialogCompany.firstName"),
        t("clients.passportDialogCompany.lastName"),
        t("clients.passportDialogCompany.function"),
        t("clients.passportDialogCompany.phone"),
        t("clients.passportDialogCompany.email"),
        "",
        ""
    ];

    const { onFormErrors, onServerError } = useToasts();

    const { mutate: removePersonCompany } = useRemovePersonComapnyMutation({
        onSuccess: () => {
            toast.custom(
                () => (
                    <SnackbarSuccess message={t("clients.passportDialogCompany.personCompanyDeleted")} />
                ),
                {
                    position: "bottom-right",
                },
            );
        },
        onError: (error) => {
            onServerError(error);
        },
    });

    const handleRemovePersonCompany = (id) => {
            removePersonCompany(id);
    }

    const rows = props.data
        .map((entry) => ({
            rowId: entry.id,
            data: [

                entry.name || "-",
                entry.surname || "-",
                 t(`company.roles.${entry.companyFunction}`) || "-",
                entry.phone || "-",
                entry.email || "-",
                entry.existingClientId ?<ClientPassportButton
                    clientId={entry.existingClientId}
                    clientType={"customer"}
                    color="primary"
                /> : "-",
                <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleRemovePersonCompany(entry.id)}
                >
                    <DeleteIcon />
                </IconButton>
            ],
        }));

    return (
        <Box sx={{ overflow: "auto", ...props.sx }}>
            <BaseTable
                stickyHeader={true}
                headers={headers}
                // @ts-ignore
                rows={rows}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                // ensure no columns are hidden
                hiddenColumns={[]}
                // no row selection for this static table
                selectedRows={[]}
                // @ts-ignore
            />
        </Box>
    );
}
